import React from 'react';
import { NavLink } from 'react-router-dom';
const services = [
    {
        count: 1,
        title: 'Doradztwo/Konsultacje',
        icon: require('./../../images/icon/idea.png'),  // Załóżmy, że jest to ikona konsultacji
        description: 'Doradzamy i pomagamy urzędnikom, firmom i klientom prywatnym na każdym etapie powstawania i funkcjonowania skateparku',
        link: '/doradztwo'
    },
    {
        count: 2,
        title: 'Projektowanie',
        icon: require('./../../images/icon/planning.png'),
        description: 'Wykonujemy projekty koncepcyjne oraz kompletną dokumentację projektową zgodnie z wymaganiami i najnowszymi trendami',
        link: '/projektowanie'
    },
    {
        count: 3,
        title: 'Wykonawstwo ',
        icon: require('./../../images/icon/hammer.png'),
        description: 'Budujemy skateparki najwyższej jakości, które są bardzo doceniane przez użytkowników w całej Polsce za ich wyjątkową trwałość i design.',
        link: '/wykonawstwo'
    },
    {
        count: 4,
        title: 'Przeglądy/Remonty',
        icon: require('./../../images/icon/renovation.png'),  // Załóżmy, że jest to ikona remontów
        description: 'Serwisujemy i modernizujemy istniejące obiekty, zapewniając bezpieczeństwo i wytrzymałość',
        link: '/przeglady'
    },
    {
        count: 5,
        title: 'Mobilne Przeszkody/Przydomowe Skateparki',
        icon: require('./../../images/icon/ramp.png'),
        description: 'Sprzedajemy i wypożyczamy mniejsze wersje katalogowych przeszkód oraz realizujemy indywidualne zamowienia',
        link: '/mobilne'
    },
    {
        count: 6,
        title: 'Warsztat/Usługi CNC',
        icon: require('./../../images/icon/cnc.png'),
        description: 'Oferujemy precyzyjne usługi cięcia i obróbki CNC, dostosowane do indywidualnych potrzeb naszych klientów',
        link: '/warsztat'
    }
]; 


var img1 = require('./../../images/background/ptn-1.png');

class AllServices extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white mobile-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                    <div className="section-content">
                        <div className="container">
                            {/* TITLE START */}
                            <div className="section-head m-b50">
                                <div className="mt-separator-outer separator-left">
                                    <div className="mt-separator">
                                        <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Od koncepcji</span> do Realizacji</h2>
                                    </div>
                                </div>
                                <h3>Zaangażowanie, pasja i wieloletnie doświadczenie w jeździe ekstremalnej kształtują każdy etap naszej pracy, od konsultacji społecznych, przez projektowanie, aż po wykonanie, tworząc skateparki, które spełniają marzenia i oczekiwania użytkowników.</h3>
                            </div>
                            {/* TITLE END */}
                            <div className="row services-v2 ">
                            {services.map((item, index) => (
                                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6 col-xs-100pc" key={index}>
                                    <div className="mt-icon-box-wraper bdr-l-1 bdr-solid bdr-gray">
                                        <div className="relative  p-a30">
                                            <div className="icon-md inline-icon m-b15 text-primary scale-in-center">
                                                <span className="icon-cell"><img src={item.icon} alt="" /></span>
                                            </div>
                                            <div className="icon-content">
                                                <h4 className="mt-tilte m-b25">{item.title}</h4>
                                                <p>{item.description}</p>
                                                <NavLink to={item.link} className="site-button-link" data-hover="Więcej">Więcej <i className="fa fa-angle-right arrow-animation" /></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                    ))}
                                
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default AllServices;